import React from 'react';

export const CheckQuestion = ({ title, question, children }) => {
  return (
    <div>
      { title && <span className='form__title'>{ title }</span> }
      <div className='radio-question'>
        <span className='form__subs'>{question}</span>
        { children }
      </div>
    </div>
  );
};
